import { trackBrandTileBrandActionCategoryClick } from "@faire/web-api--source/events/brandTile/actionCategoryClick/brand";
import { trackBrandTileBrandHeaderActionCategoryClick } from "@faire/web-api--source/events/brandTile/actionCategoryClick/brandHeader";
import { trackBrandTileBrandHeaderMiddleActionCategoryClick } from "@faire/web-api--source/events/brandTile/actionCategoryClick/brandHeaderMiddle";
import { trackBrandTileBrandHeaderRightActionCategoryClick } from "@faire/web-api--source/events/brandTile/actionCategoryClick/brandHeaderRight";
import { trackBrandTileMiddleActionCategoryClick } from "@faire/web-api--source/events/brandTile/actionCategoryClick/middle";
import { trackBrandTileRightActionCategoryClick } from "@faire/web-api--source/events/brandTile/actionCategoryClick/right";
import React, { useMemo } from "react";

import { BrandImpressionType } from "../BrandImpressionType";

import { ClickContext } from "./BrandTileImpressionContexts";
import { ImpressionProviderProps } from "./ImpressionProviderProps";

export const BrandTileClickImpressionProvider: React.FC<
  React.PropsWithChildren<ImpressionProviderProps>
> = ({
  children,
  requestId,
  screenContext,
  containerContext,
  contextToken,
  type,
}) => {
  const value = useMemo(
    () => ({
      onLeftClick: ({ brandToken, impressionId }: ClickArgs) =>
        reportLeftClick({
          requestId,
          impressionId,
          brandToken,
          screenContext,
          containerContext,
          contextToken,
          type,
        }),
      onMiddleClick: ({ brandToken, impressionId }: ClickArgs) =>
        reportMiddleClick({
          requestId,
          impressionId,
          brandToken,
          screenContext,
          containerContext,
          contextToken,
          type,
        }),
      onRightClick: ({ brandToken, impressionId }: ClickArgs) =>
        reportRightClick({
          requestId,
          impressionId,
          brandToken,
          screenContext,
          containerContext,
          contextToken,
          type,
        }),
    }),
    [requestId, screenContext, containerContext, contextToken, type]
  );
  return (
    <ClickContext.Provider value={value}>{children}</ClickContext.Provider>
  );
};

type ClickArgs = { brandToken: string; impressionId: string };

const reportLeftClick = (args: {
  requestId: string | undefined;
  impressionId: string;
  brandToken: string;
  screenContext: string;
  containerContext: string;
  contextToken: string | undefined;
  type: BrandImpressionType | undefined;
}) => {
  switch (args.type) {
    case BrandImpressionType.HEADER:
      trackBrandTileBrandHeaderActionCategoryClick(
        args.requestId ?? "",
        args.impressionId,
        args.brandToken,
        args.screenContext,
        args.containerContext,
        args.contextToken ?? ""
      );
      break;
    case BrandImpressionType.TILE:
    default:
      trackBrandTileBrandActionCategoryClick(
        args.requestId ?? "",
        args.impressionId,
        args.brandToken,
        args.screenContext,
        args.containerContext,
        args.contextToken ?? ""
      );
  }
};

const reportMiddleClick = (args: {
  requestId: string | undefined;
  impressionId: string;
  brandToken: string;
  screenContext: string;
  containerContext: string;
  contextToken: string | undefined;
  type: BrandImpressionType | undefined;
}) => {
  switch (args.type) {
    case BrandImpressionType.HEADER:
      trackBrandTileBrandHeaderMiddleActionCategoryClick(
        args.requestId ?? "",
        args.impressionId,
        args.brandToken,
        args.screenContext,
        args.containerContext,
        args.contextToken ?? ""
      );
      break;
    case BrandImpressionType.TILE:
    default:
      trackBrandTileMiddleActionCategoryClick(
        args.requestId ?? "",
        args.impressionId,
        args.brandToken,
        args.screenContext,
        args.containerContext,
        args.contextToken ?? ""
      );
  }
};

const reportRightClick = (args: {
  requestId: string | undefined;
  impressionId: string;
  brandToken: string;
  screenContext: string;
  containerContext: string;
  contextToken: string | undefined;
  type: BrandImpressionType | undefined;
}) => {
  switch (args.type) {
    case BrandImpressionType.HEADER:
      trackBrandTileBrandHeaderRightActionCategoryClick(
        args.requestId ?? "",
        args.impressionId,
        args.brandToken,
        args.screenContext,
        args.containerContext,
        args.contextToken ?? ""
      );
      break;
    case BrandImpressionType.TILE:
    default:
      trackBrandTileRightActionCategoryClick(
        args.requestId ?? "",
        args.impressionId,
        args.brandToken,
        args.screenContext,
        args.containerContext,
        args.contextToken ?? ""
      );
  }
};
